export const GET_DEPARTMENTS_REQUEST = 'GET_DEPARTMENTS_REQUEST';
export const GET_DEPARTMENT_REQUEST = 'GET_DEPARTMENT_REQUEST';
export const GET_DEPARTMENT_BY_USER_REQUEST = 'GET_DEPARTMENT_BY_USER_REQUEST';
export const CREATE_DEPARTMENT_REQUEST = 'CREATE_DEPARTMENT_REQUEST';
export const UPDATE_DEPARTMENT_REQUEST = 'UPDATE_DEPARTMENT_REQUEST';
export const ADD_USERS_TO_DEPARTMENT_REQUEST = 'ADD_USERS_TO_DEPARTMENT_REQUEST';
export const REMOVE_USERS_FROM_DEPARTMENT_REQUEST = 'REMOVE_USERS_FROM_DEPARTMENT_REQUEST';
export const DELETE_DEPARTMENT_REQUEST = 'DELETE_DEPARTMENT_REQUEST';

export const getDepartments = (start, limit, callback) => ({
    type: GET_DEPARTMENTS_REQUEST,
    payload: { start, limit, callback },
}); 

export const getDepartment = (id, callback) => ({
    type: GET_DEPARTMENT_REQUEST,
    payload: { id, callback },
});

export const getDepartmentByUser = (userId, callback) => ({
    type: GET_DEPARTMENT_BY_USER_REQUEST,
    payload: { userId, callback },
});

export const createDepartment = (department, callback) => ({
    type: CREATE_DEPARTMENT_REQUEST,
    payload: { department, callback },
});

export const updateDepartment = (id, department, callback) => ({
    type: UPDATE_DEPARTMENT_REQUEST,
    payload: { id, department, callback },
});

export const addUsersToDepartment = (id, users, callback) => ({
    type: ADD_USERS_TO_DEPARTMENT_REQUEST,
    payload: { id, users, callback },
});

export const removeUsersFromDepartment = (id, users, callback) => ({
    type: REMOVE_USERS_FROM_DEPARTMENT_REQUEST,
    payload: { id, users, callback },
});

export const deleteDepartment = (id, callback) => ({
    type: DELETE_DEPARTMENT_REQUEST,
    payload: { id, callback },
});